import React from 'react';
import ReportSegments from '../../../ReportSegments/ReportSegments';
import ReportByReactivationComponent from '../../../../utils/ReportByReactivationComponent/ReportByReactivationComponent';
import { statisticsByReactivation } from '../../../../config';

// Filter (segment) rows of the page: the shared ReportSegments with this page's report params and translations
export const StatisticsByReactivationSegments = (props) => (
    <ReportSegments
        {...props}
        segmentKeys={(statisticsByReactivation && statisticsByReactivation.groupParamsSegment) || []}
        reportComponent={ReportByReactivationComponent}
        translationKey="statisticsByReactivation"
    />
);

export default StatisticsByReactivationSegments;
